module.exports = __webpack_public_path__ + "img/logo.2b5b96b1.png";